import React, { useState, useEffect } from "react";
import { Modal, Box, Typography, TextField, Button } from "@mui/material";
import APIURL from "../api/apiClient"; // your axios instance
import { message } from "antd";

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    borderRadius: 2,
    boxShadow: 24,
    p: 4,
};

export default function AddOfferModal({ open, handleClose, itemId }) {
    const [item, setItem] = useState(null);
    const [offerPrice, setOfferPrice] = useState("");
    const [offerFrom, setOfferFrom] = useState("");
    const [offerTo, setOfferTo] = useState("");
    const [errors, setErrors] = useState({});

    useEffect(() => {
        console.log("🔄 useEffect triggered with:", { itemId, open });

        if (itemId && open) {
            console.log(`📡 Fetching item details for ID: ${itemId}`);

            APIURL.get(`/fetchitemid.php?id=${itemId}`)
                .then((res) => {
                    console.log("✅ API response received:", res);
                    console.log("📦 Response data:", res.data);

                    // Use res.data if your API returns { id, name, brand, offer_price, offer_from_at, offer_to_at }
                    const data = res;

                    setItem(data);

                    // Pre-fill fields if they exist
                    setOfferPrice(data.offer_price || "");
                    setOfferFrom(data.offer_from_at || "");
                    setOfferTo(data.offer_to_at || "");
                })
                .catch((err) => {
                    console.error("❌ Error fetching item:", err);
                });
        } else {
            console.log("⚠️ Skipping fetch — missing itemId or modal not open.");
            setItem(null);
            setOfferPrice("");
            setOfferFrom("");
            setOfferTo("");
        }
    }, [itemId, open]);


    const validate = () => {
        let temp = {};
        temp.offerPrice = offerPrice ? "" : "Offer price is required";
        temp.offerFrom = offerFrom ? "" : "Offer from date is required";
        temp.offerTo = offerTo ? "" : "Offer to date is required";

        if (offerFrom && offerTo && new Date(offerTo) <= new Date(offerFrom)) {
            temp.offerTo = "Offer to date must be after from date";
        }

        setErrors(temp);
        return Object.values(temp).every((x) => x === "");
    };

    const handleSubmit = async () => {
        if (!validate()) return;

        try {
            const payload = {
                id: itemId,
                offer_price: offerPrice,
                offer_from_at: offerFrom,
                offer_to_at: offerTo,
            };

            console.log("📦 Sending JSON payload:", payload);

            let response = await APIURL.post("/itemoffer.php", payload); // no FormData

            console.log("✅ Response from backend:", response);

             // If response is a string (not JSON), try to parse it
                    if (typeof response === "string") {
                        try {
                            response = JSON.parse(response.trim());
                        } catch {
                            // fallback if not JSON
                            response = { success: false, message: response };
                        }
                    }

            if (response.status === "success") {
                message.success(response.message || "Offer Item Updated Successfully")
                handleClose();
            }
        } catch (error) {
            console.error("❌ Error submitting offer:", error);
        }
    };

    return (
        <Modal open={open} onClose={handleClose}>
            <Box sx={style}>
                <Typography variant="h6" mb={2}>
                    Add Offer
                </Typography>

                {item ? (
                    <>
                        <Typography variant="subtitle1" mb={1}>
                            Item Name:
                            {item.name || "Unnamed Item"}
                        </Typography>
                        <Typography variant="body2" mb={2}>
                            Brand:
                            {item.brand || "No Brand available."}
                        </Typography>
                    </>
                ) : (
                    <Typography variant="body2" mb={2}>
                        Loading item details...
                    </Typography>
                )}

                <TextField
                    fullWidth
                    label="Offer Price"
                    type="number"
                    size="small"
                    value={offerPrice}
                    onChange={(e) => setOfferPrice(e.target.value)}
                    error={!!errors.offerPrice}
                    helperText={errors.offerPrice}
                    margin="dense"
                />
                <TextField
                    fullWidth
                    label="Offer From"
                    type="datetime-local"
                    size="small"
                    value={offerFrom}
                    onChange={(e) => setOfferFrom(e.target.value)}
                    error={!!errors.offerFrom}
                    helperText={errors.offerFrom}
                    margin="dense"
                    InputLabelProps={{ shrink: true }}
                />
                <TextField
                    fullWidth
                    label="Offer To"
                    type="datetime-local"
                    size="small"
                    value={offerTo}
                    onChange={(e) => setOfferTo(e.target.value)}
                    error={!!errors.offerTo}
                    helperText={errors.offerTo}
                    margin="dense"
                    InputLabelProps={{ shrink: true }}
                />

                <Box mt={3} display="flex" justifyContent="flex-end" gap={1}>
                    <Button variant="contained" color="primary" onClick={handleSubmit}>
                        Submit
                    </Button>
                    <Button variant="outlined" onClick={handleClose}>
                        Cancel
                    </Button>
                </Box>
            </Box>
        </Modal>
    );
}
